import React, { useContext, useEffect, useMemo, useState, FC } from 'react';
import { ALL_MODELS, ALL_SERIES } from '../../../../constants/seriesFilter.constants';
import { FilterContext } from '../../fiilterContext';
import SearchBox from '../../../@shared/filters/components/searchBox';
import './styles.scss';

const Search: FC<{}> = () => {
  const filters = useContext(FilterContext);
  const { updateFilters, searchedTerm: prevSearchedTerm } = filters;
  const [searchedTerm, setSearchedTerm] = useState(prevSearchedTerm || '');
  const { model } = useContext(FilterContext);
  const lowerCasesearchedTerm = searchedTerm.toLocaleLowerCase();

  useEffect(() => {
    setSearchedTerm(prevSearchedTerm);
  }, [filters]);

  const filterdCards = useMemo(
    () => (searchedTerm?.length >= 3 ? model.filterCardsBySearch(model.fields?.apiData?.cards || [], lowerCasesearchedTerm) : []),
    [searchedTerm]
  );

  const updateSearchedTextFilter = (searchedTerm) => {
    updateFilters({
      seriesSelectedInd: ALL_SERIES,
      modelSelectedInd: ALL_MODELS,
      searchedTerm,
    });
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    searchedTerm.length > 0 && updateSearchedTextFilter(searchedTerm);
  };

  return (
    <SearchBox
      searchedTerm={searchedTerm}
      filterdCards={filterdCards}
      handleSearchSubmit={handleSearchSubmit}
      handleChange={({ target }) => setSearchedTerm(target?.value || '')}
      handleSuggestionClick={(title) => updateSearchedTextFilter(title || '')}
      handleClearSearch={() => updateSearchedTextFilter('')}
      titleDictionaryTerm="cnhi-filter-search-title"
      ctaDictionaryTerm="cnhi-filter-search-cta"
      extraClassName="attachment-search"
    />
  );
};

export default Search;
